// @ts-nocheck
import { CASE_COMMENTS_ADD_REPLY_ERROR, CASE_COMMENTS_ADD_REPLY_LOADING, CASE_COMMENTS_ADD_REPLY_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseCommentsAddReplyReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_COMMENTS_ADD_REPLY_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_COMMENTS_ADD_REPLY_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_COMMENTS_ADD_REPLY_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

